import React, { ReactNode } from 'react';

import styled from 'styled-components';

import Checkbox, { CheckboxState } from '@adsk/alloy-react-checkbox';
import theme from '@adsk/alloy-react-theme';

const StyledLabel = styled.label`
  ${theme.typography.labelSmall}
  display: flex;
  margin-right: 8px;
  color: ${theme.colors.charcoal800};
`;

const FooterOption = ({
  label,
  defaultChecked,
  onChange,
}: {
  label: ReactNode;
  defaultChecked?: boolean;
  onChange?: (
    state: CheckboxState,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
}) => {
  return (
    <StyledLabel>
      <Checkbox
        onChange={onChange}
        defaultChecked={defaultChecked}
        style={{ marginRight: 8 }}
      />
      {label}
    </StyledLabel>
  );
};

export default FooterOption;
